module.exports = __webpack_public_path__ + "img/ss_awa.1093b9f.jpg";